import React from "react";
import { FormDemoInstitucional } from "../../components/FormDemoInstitucional";
import useObtenerSubsecciones from "../../js/translations/useObtenerSubsecciones";

/**
 * Este componente renderiza el contenido de la pestaña 'Solicitud de demo"
 */
export const DemoInstitucional = () => {
  const {textosSubSecciones:textos} = useObtenerSubsecciones('tienda_makemake');
  return (
    <div className="demo-section">
      <section className="container py-5">
        <div className="d-flex institucional-title">
          <hr className="institucional-line" aria-hidden={true} />
          <h2 className="onbackground-primary--color flex-grow-1 w-100 text-center">{textos?.institucional?.demo?.titulo || 'Pide un demo'}</h2>
          <hr className="institucional-line" aria-hidden={true} />
        </div>
        <div className="py-4">
          <FormDemoInstitucional />
        </div>
      </section>
    </div>
  )
}